import React from "react";
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.div`
  display: flex;
  user-select: none;
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0px;
  clip: rect(0px 0px 0px 0px);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0px;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke: var(--se-success-contrast, white);
  stroke: ${props => props.textColor ? props.textColor : 'white'};
  stroke-width: 2px;
  vertical-align: top !important;
`;

const Label = styled.label`
  font-size: 14px;
  font-weight: 300;
  cursor: pointer;
`;

const StyledCheckbox = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
  width: 14px;
  height: 14px;
  border: 1px solid #CBCBCB;
  border: 1px solid var(--se-hover-standard, #CBCBCB);
  ${props => props.checked ? `
    background: ${props.color || '#3DCD58'}
    border-color: ${props.color || '#3DCD58'};
  ` : `
    background: white;
  `}
  cursor: pointer;
  ${props => props.disabled && `opacity: 0.5; cursor: default; ${Label} {cursor: default;}`}

  border-radius: 3px;
  transition: all 150ms;

  ${Icon} {
    visibility: ${props => props.checked ? 'visible' : 'hidden'};
  }
`;

class Checkbox extends React.PureComponent {

  static propTypes = {
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    checked: PropTypes.bool,
    label: PropTypes.string,
    color: PropTypes.string,
    textColor: PropTypes.string
  }

  handleChange(event) {
    if (!this.props.disabled && this.props.onChange) {
      event.stopPropagation();
      this.props.onChange(event);
    }
  }

  render() {
    return (
      <Container>
        <HiddenCheckbox checked={this.props.checked} onChange={(event) => { this.handleChange(event); }} />
        <StyledCheckbox color={this.props.color} disabled={this.props.disabled} checked={this.props.checked} onClick={(event) => { this.handleChange(event); }}>
          <Icon textColor={this.props.textColor} viewBox="0 0 24 24" fill="current">
            <polyline points="20 6 9 17 4 12" />
          </Icon>
        </StyledCheckbox>
        <Label disabled={this.props.disabled} onClick={(event) => { this.handleChange(event); }}>{this.props.label}</Label>
      </Container>
    );
  }
}

export default Checkbox;
